var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      class: { show: _vm.showModal },
      on: {
        click: function ($event) {
          return _vm.onClose($event)
        },
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c(
          "header",
          [
            _vm._v(_vm._s(_vm.title) + "\n          "),
            _vm.showRefreshButton
              ? [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "150px",
                        "margin-right": "10px",
                        float: "right",
                        clear: "both",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticStyle: {
                            "margin-top": "0px",
                            padding: "3px",
                            "padding-left": "5px",
                            "padding-right": "5px",
                          },
                          attrs: { title: "Refresh" },
                          on: {
                            click: function ($event) {
                              return _vm.reloadLocation()
                            },
                          },
                        },
                        [_vm._v("Refresh manually\n              ")]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("span", { attrs: { title: "Close" } }),
          ],
          2
        ),
        _vm._v(" "),
        _c("article", [_vm._t("default")], 2),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }